import { API_URL } from '../../../../utils/config';

export const SEARCH_FOR_CUSTOMER_URL = `${API_URL}/users/searchuser`;